import { useGetTradingConfig } from '@ui/services/contract/hooks/TradingConfigFacet/useGetTradingConfig';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

import { useCollateralToken } from '../components/TradeModule/store/useCollateralToken';
import { usePayTokenPriceLatest } from './usePayTokenPriceLatest';

export const useGetExecutionFeeUsd = () => {
  const { data: tradingConfig } = useGetTradingConfig();

  return tradingConfig?.executionFeeUsd;
};

export const useGetExecutionFeeInPayToken = () => {
  const executionFeeUsd = useGetExecutionFeeUsd();
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());
  const payTokenPrice = usePayTokenPriceLatest(payToken);

  return useMemo(() => {
    if (isNil(executionFeeUsd) || isNil(payTokenPrice)) return undefined;

    return executionFeeUsd?.div(payTokenPrice);
  }, [executionFeeUsd, payTokenPrice]);
};
